import { Component, OnInit, HostListener, Inject } from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  UntypedFormBuilder,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { map } from 'rxjs/operators';

import { FormPermission } from '@pages/modules-permission/interfaces/FormPermission';
import { SwalService } from '@shared/utils/swal.service';
import { UserService } from '@pages/user/services/user.service';
import { FormsService } from '@pages/modules-permission/services/forms.service';
import { RolService } from '@pages/rol/services/rol.service';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-control-form-permission',
  templateUrl: './control-form-permission.component.html',
  styleUrls: ['./control-form-permission.component.css'],
})
export class ControlFormPermissionComponent implements OnInit {
  private _user: string = this._userServices.userCurrent;
  public loading: boolean = false;
  public breakpoint: number;
  usser: any = JSON.parse(sessionStorage.getItem('Usser'));
  jsonModules: any[] = [];
  roles: any[] = [];
  habilitado: any[] = [];

  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<ControlFormPermissionComponent>,
    private _swalService: SwalService,
    private _formsService: FormsService,
    private _userServices: UserService,
    private _rolServices: RolService,
    @Inject(MAT_DIALOG_DATA) public model: FormPermission
  ) {
    _dialogRef.disableClose = true;
    if (this.model !== null) {
      const setModel = {
        formName: model.formName,
        description: model.description,
        enable: model.enable,
        userCreator: model.userCreator,
        permissionFormId: model.permissionFormId,
        formId: model.formId,
        rolId: model.rolId,
        create: model.create,
        update: model.update,
        delete: model.delete,
        read: model.read,
      };
      this.form.setValue(setModel);
    }
  }

  form = this._fb.group({
    formName: [''],
    rolId: ['', Validators.required],
    enable: ['', Validators.required],
    userCreator: [this.usser],
    formId: [''],
    permissionFormId: [0],
    description: [''],
    create:[''],
    read: [''],
    update: [''],
    delete: ['']
  });

  ngOnInit() {
    this.breakpoint = window.innerWidth <= 400 ? 1 : 2;
    this.jsonModules = JSON.parse(sessionStorage.getItem('Forms'));
    this.usser = JSON.parse(sessionStorage.getItem('Usser'));
    this.loadRols();
  }

  loadRols() {
    this._rolServices.read().subscribe((res) => {
      this.roles = res.data;
    });
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 400 ? 1 : 2;
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    this._dialogRef.close();
  }

  close() {
    this._dialogRef.close();
  }

  create(model: FormPermission) {
    if (this.form.valid) {
      this.loading = true;
      model.enable = true;
      model.create = true;
      model.delete = true;
      model.update = true;
      model.read = true;
      this._formsService.create(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Agregado');
        } else this._swalService.error('No Agregado');
      });
    }
  }

  update(model: FormPermission) {
    if (this.form.valid) {
      this.loading = true;
      this._formsService.update(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Editado');
        } else this._swalService.error('No Editado');
      });
    }
  }

  //#region Get Fb
  formValue(value: string) {
    return this.form.get(value);
  }
  //#endregion

  //#region AsyncValidation
  singleClave(): AsyncValidatorFn {
    return (
      control: AbstractControl
    ): Promise<ValidationErrors> | Observable<any> => {
      if (this.model) return of(true);
      else {
        return this._formsService.readOne(control.value).pipe(
          map((res) => {
            if (res.exito === 1) return { singleClave: true };
            return null;
          })
        );
      }
    };
  }
}
